import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptOpProject,
  rejectOpProject,
} from "../../../../store/slices/OpProjectAssignSlices/OpProjectAssignAction";
import { useSnackbar } from "notistack";
import { fetchEmployees } from "../../../../store/slices/employeeSlice";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";

const OpProjectAssignAction = ({
  index,
  row,
  setIsLoading,
  setOpenMenuIdx,
  openMenuIdx,
  setOpenTaskIndex,
  openTaskIndex,
  SetshowTaskTable,
  showTaskTable,
  handleSelectProjectWorkEntries,
  handleSelectProjectDescription,
  matchedRowEntries,
  handleSelectProjectHardwareParts,
  matchedRowHardwareEntries,
  matchedRowDesctiption,
  setClickedProject, projectData,
  isViewOnly = false
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);

  const { employees } = useSelector((state) => state.employees);

  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  const LoggedEmp = localStorage.getItem("email");

  const [loggedOp, setLoggedOp] = useState(null);
  useEffect(() => {
    if (employees?.length > 0 && LoggedEmp) {
      const filteredOp = employees.find(
        (emp) => emp.EmpEmail?.toLowerCase() === LoggedEmp.toLowerCase()
      );
      setLoggedOp(filteredOp || null);
    }
  }, [employees, LoggedEmp]);

  const matchedPerson = row?.Assignedperson?.find(
    (person) => person?.email === loggedOp?.EmpEmail
  );
  console.log("Gdgdfgdf", matchedPerson)
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenMenuIdx(null);
      }
    }

    // Use 'click' instead of 'mousedown' to allow the button's onClick to complete first
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [setOpenMenuIdx]);

  const handleAccept = async () => {
    if (isViewOnly) return;
    const acceptPayload = {
      projectId: row._id,
      userId: loggedOp._id,
    };
    setIsLoading(true);
    try {
      await dispatch(acceptOpProject(acceptPayload));
      enqueueSnackbar("Project Tasks Accepted", {
        variant: "success",
      });
      dispatch(fetchAllProjects());
    } catch {
      enqueueSnackbar("Failed To Accept Project Tasks", {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleReject = async () => {
    if (isViewOnly) return;
    const rejectPayload = {
      projectId: row._id,
      userId: loggedOp._id,
    };
    setIsLoading(true);
    try {
      await dispatch(rejectOpProject(rejectPayload));
      enqueueSnackbar("Project Tasks Rejected", {
        variant: "success",
      });
      dispatch(fetchAllProjects());
    } catch {
      enqueueSnackbar("Failed To Reject Project Tasks", {
        variant: "errro",
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="m-auto">
      <div
        ref={wrapperRef}
        className="relative inline-block" // use inline-block to wrap the button tightly
      >
        <button
          disabled={isViewOnly || matchedPerson?.operationaction === "reject"}
          type="button"
          onClick={(e) => {
            if (isViewOnly) return;
            e.stopPropagation();
            setOpenMenuIdx(openMenuIdx === index ? null : index);
          }}
          className={`drop btn w-28
            relative flex items-center px-2 py-1 pb-1  truncate break-words justify-between border border-gray-400 text-nowrap rounded-md
              shadow-md text-xs overflow-hidden text-ellipsis ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none" : "bg-white"}`}
        ><>
            {matchedPerson?.operationaction === "reject" ? (
              <span className="cursor-not-allowed">Rejected</span>
            ) : matchedPerson?.manageraction === "review" ? (
              <span>Review</span>
            ) : matchedPerson?.manageraction === "re-assigned" ? (
              <span>Reassign</span>
            ) : (
              <>
                {matchedPerson?.operationaction === "accept" ? "Accepted" : "Select"}
                
              </>
            )}
            <ExpandMoreIcon className={`absolute top-1 right-0 ${isViewOnly ? "bg-[#e5e7eb]" : "bg-white"}`} />
          </>
        </button>

        {openMenuIdx === index && !isViewOnly && (
          <div
            style={{ zIndex: 9999 }}
            className="absolute top-full left-0 w-28  p-1 bg-white text-xs border border-gray-300 shadow-lg flex flex-col gap-1"
          >
            {/* <div
              className="p-1 hover:bg-gray-200 text-start cursor-pointer"
              onClick={() => {
                setClickedProject(row)
                SetshowTaskTable(showTaskTable === row?._id ? null : row?._id);
                setOpenTaskIndex(openTaskIndex === index ? null : index);
                handleSelectProjectWorkEntries(row._id, matchedRowEntries);
                handleSelectProjectDescription(row._id, matchedRowDesctiption);
                handleSelectProjectHardwareParts(
                  row._id,
                  matchedRowHardwareEntries
                );
              }}
            >
              {openTaskIndex === index ? "Hide" : "View"}
            </div> */}

            {/* {matchedPerson?.operationaction !== "accept" && ( */}
            <div
              className="p-1 hover:bg-gray-200 text-start cursor-pointer"
              onClick={() => {
                if (matchedPerson?.operationaction !== "accept") {
                  handleAccept(); // ✅ call only if not already accepted
                } 
                setClickedProject(row)
                SetshowTaskTable(showTaskTable === row?._id ? null : row?._id);
                setOpenTaskIndex(openTaskIndex === index ? null : index);
                handleSelectProjectWorkEntries(row._id, projectData.find((p) => p.projectid === row._id)
                  ?.matchedRowEntries || []);
                handleSelectProjectDescription(row._id, projectData.find((p) => p.projectid === row._id)
                  ?.matchedRowDesctiption || [], row);
                handleSelectProjectHardwareParts(
                  row._id,
                  projectData.find((p) => p.projectid === row._id)
                    ?.matchedRowHardwareEntries || []
                );
                setOpenMenuIdx(null);

              }}
            >
              {matchedPerson?.operationaction === "accept" ? "View" : "Accept"}
            </div>
            {/* )} */}
            {(matchedPerson?.projecttracktaskStatus !== "submit") && (
              <div
                className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                onClick={() => {
                  setOpenMenuIdx(null);
                  handleReject();
                  SetshowTaskTable(false)
                }}
              >
                Reject
              </div>
            )}


          </div>
        )}
      </div>
    </div>
  );
};

export default OpProjectAssignAction;
